import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, AlertTriangle } from 'lucide-react';
import axios from 'axios';
import { API_BASE } from '../../config';

export default function WikiLink({ slug, children }) {
    const [exists, setExists] = useState(true);

    useEffect(() => {
        if (!slug) return;
        axios.get(`${API_BASE}/wiki/entries/${slug}`).then(() => setExists(true)).catch(() => setExists(false));
    }, [slug]);

    if (!exists) {
        return (
            <span style={{ color: 'var(--error)', fontSize: '0.85rem', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                <AlertTriangle size={12} />
                {children || slug}
            </span>
        );
    }

    return (
        <Link
            to={`/wiki/entry/${slug}`}
            style={{
                color: 'var(--gold)',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.25rem',
                fontSize: '0.85rem',
                borderBottom: '1px dashed var(--gold)',
            }}
        >
            <BookOpen size={12} />
            {children || slug}
        </Link>
    );
}